export function isVideoElementPaused(videoElement) {
    if (videoElement)
        return videoElement.paused || videoElement.ended;
    else
        return false;
}
export function isVideoElementLoading(videoElement) {
    return (!isVideoElementPaused(videoElement) &&
        videoElement.readyState < videoElement.HAVE_FUTURE_DATA);
}
export function isVideoElementPlaying(videoElement) {
    if (videoElement)
        return (!isVideoElementPaused(videoElement) &&
            !isVideoElementLoading(videoElement));
    else
        return false;
}
